import { axiosBaseQuery } from "@/lib/baseQueries";
import { createApi } from "@reduxjs/toolkit/query/react";

export const oauthApi = createApi({
  reducerPath: "oauthApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["oauth"],
  endpoints: (builder) => ({
    getYoutubeAuthUrl: builder.query<
      { url: string },
      {
        reconnect?: boolean;
        workspaceId?: string;
        delegated?: boolean;
        token?: string;
      } | void
    >({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params?.reconnect) {
          searchParams.append("reconnect", "true");
          if (params.workspaceId) {
            searchParams.append("workspace_id", params.workspaceId);
          }
        }
        if (params?.delegated) {
          searchParams.append("delegated", "true");
          if (params.token) {
            searchParams.append("token", params.token);
          }
        }
        const queryString = searchParams.toString();
        return queryString
          ? `/v1/oauth/youtube?${queryString}`
          : "/v1/oauth/youtube";
      },
    }),

    checkConnectionStatus: builder.query({
      query: () => "/v1/workspaces",
      providesTags: ["oauth"],
    }),

    failOAuth: builder.mutation<{ message: string }, { state: string }>({
      query: (body) => ({
        url: "/v1/oauth/failed",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetYoutubeAuthUrlQuery,
  useCheckConnectionStatusQuery,
  useLazyCheckConnectionStatusQuery,
  useFailOAuthMutation,
} = oauthApi;

